import React, {useContext, useEffect, useState} from "react"
import Container from "../components/Container";
import Api from "../utilis/api/service"
import workflow from "../utilis/interfaces/Workflow";
import urls from "../utilis/api/Urls";
import {Divider, Result, Timeline} from 'antd';
import {AxiosResponse} from "axios";
import AppContext from "../utilis/contexts/AppContext";
import Texts from "../utilis/defaults/Text";
import {useLocation} from "react-router-dom";
import LocalStorage from "../utilis/tools/LocalStorage";
import {FrownOutlined} from "@ant-design/icons";
import TrackPaymentCard from "../components/TrackPaymentCard";
const WorkFlow = () => {
    const [bills, setBills] = useState<Array<any>>([]);

    const appContext=useContext(AppContext);
    const {state:State}:any = useLocation();
    const { TraceNumber, BillId,Cellphone } = State;

    useEffect(() => {
        appContext.handleLoading(true)
        if(TraceNumber){
            Api.post(urls.GetTrackPaymentBills,{
                Cellphone:Cellphone,
                BillId:BillId,
                TraceNumber:TraceNumber
            },{
                headers: {
                    "Authorization": LocalStorage.getToken().token_type + " " + LocalStorage.getToken().access_token
                }
            }).then((response:AxiosResponse)=>{

                const {data}=response;
                const {Status,Data}=data;

                if(Status===0){
                    const {bills} = Data;

                    setBills(bills)
                }
                if(Status===-1){
                    setBills([])
                }
            }).catch(e=>{

            }).finally(()=>{
                appContext.handleLoading(false)
            })
        }




    }, [])
    return <>
        <Divider><h3 className="font-bold ">پیگیری پرداخت</h3></Divider>
        {bills.map((item:any,index)=><TrackPaymentCard key={index+'track-payment-list'} item={item} />)}
        {bills.length===0  && <Result
            icon={<FrownOutlined />}
            title=""
            subTitle="هیچ پرداختی  یافت نشد."

        />}
         </>
}
export default WorkFlow;